import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_campaign_execution_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  campaign_event_guid: fromDatatype.GuidDataFieldInterface;
  campaign_status: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  is_processed: boolean;
  is_not_sent: boolean;
  is_sent: boolean;
  is_delivered: boolean;
  is_read: boolean;
  is_replied: boolean;
  processed_date_time: fromDatatype.TimestampTzDatatypeInterface;
  not_sent_date_time: fromDatatype.TimestampTzDatatypeInterface;
  sent_date_time: fromDatatype.TimestampTzDatatypeInterface;
  delivered_date_time: fromDatatype.TimestampTzDatatypeInterface;
  read_date_time: fromDatatype.TimestampTzDatatypeInterface;
  replied_date_time: fromDatatype.TimestampTzDatatypeInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
}

export class bl_dgmkt_campaign_execution_hdr_RowClass
  implements bl_dgmkt_campaign_execution_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  campaign_event_guid: fromDatatype.GuidDataFieldInterface;
  campaign_status: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  is_processed: boolean;
  is_not_sent: boolean;
  is_sent: boolean;
  is_delivered: boolean;
  is_read: boolean;
  is_replied: boolean;
  processed_date_time: fromDatatype.TimestampTzDatatypeInterface;
  not_sent_date_time: fromDatatype.TimestampTzDatatypeInterface;
  sent_date_time: fromDatatype.TimestampTzDatatypeInterface;
  delivered_date_time: fromDatatype.TimestampTzDatatypeInterface;
  read_date_time: fromDatatype.TimestampTzDatatypeInterface;
  replied_date_time: fromDatatype.TimestampTzDatatypeInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
}
